import { render, staticRenderFns } from "./homepage_button.vue?vue&type=template&id=cb114996&scoped=true&"
import script from "./homepage_button.vue?vue&type=script&lang=js&"
export * from "./homepage_button.vue?vue&type=script&lang=js&"
import style0 from "./homepage_button.vue?vue&type=style&index=0&id=cb114996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb114996",
  null
  
)

export default component.exports